import { css } from '@emotion/css';
import { notification } from 'antd';

const className = css`
  width: 420px;
  height: 32px;
  padding: 0;
  background: var(--fett-surface-warning-bg);
  animation-duration: 0s;
  .ant-notification-notice-close {
    top: 6px;
    right: 10px;
  }
  .ant-notification-notice-content {
    width: 420px;
    height: 100%;
  }
  .ant-notification-notice-with-icon {
    display: flex;
    align-items: center;
    width: 420px;
    height: 100%;
    padding-right: 25px;
    font-size: 14px;
    > .ant-notification-notice-icon {
      position: unset;
      margin: 0 10px;
      line-height: 16px;
      font-size: 16px;
    }
    > .ant-notification-notice-message {
      margin: 0;
      padding: 0;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    > .ant-notification-notice-description {
      flex: 0 0 auto;
      margin-left: 0;
    }
  }
`;

let lastKey: string | undefined;

const { close, open } = notification;

function aNotification(props: Parameters<typeof open>[0]) {
  if (lastKey) {
    close(lastKey);
  }

  lastKey = props.key;

  open({
    top: 58,
    className,
    ...props,
  });
}

export { close };

export default aNotification;
